export default {
    SET_STOCK_IMAGES(state, stockImages) {
        state.stockImages = stockImages
    },
    ADD_STOCK_IMAGES(state, image) {
        const ItemIndex = state.stockImages.findIndex((w) => w.id === image.id )
        if ( ItemIndex === -1 ){
            state.stockImages.push(image)
        }
    },
    DELETE_STOCK_IMAGES(state, imageId) {
        const ItemIndex = state.stockImages.findIndex((w) => w.id === imageId)
        if ( ItemIndex !== -1 ){
            state.stockImages.splice(ItemIndex, 1)
        }
    }
}
